import { Suspense } from "react";
import { ToolsSkeleton } from "./skeletons/dashboard-skeletons";
import { CardsWidget } from "./widgets/cards-widget";
import { MetricsWidget } from "./widgets/metrics-widget";
import { ToolsWidget } from "./widgets/tools-widget";

export const Dashboard = () => (
  <div className="flex flex-col gap-5">
    <MetricsWidget />

    <CardsWidget />

    <Suspense fallback={<ToolsSkeleton />}>
      <ToolsWidget />
    </Suspense>
  </div>
);
